import { colors, r8, s16, s4, shadowM } from '@ardoq/design-tokens';
import { FlexBox } from '@ardoq/layout';
import { type I18nLocale } from '@ardoq/i18n';
import styled, { css } from 'styled-components';
import { Popover } from './Popover';
import { FormatListBulletedIcon, IconSize } from '@ardoq/icons';

type MatrixCellProps = {
  i18nLocale: I18nLocale;
  title: string;
  count: number;
  caption: string;
  color: string;
  preview: string[];
};

export const MatrixCell = ({
  i18nLocale,
  title,
  count,
  caption,
  color,
  preview,
}: MatrixCellProps) => {
  return (
    <ColoredCell color={color} disabled={count === 0}>
      <MatrixCellQuantity>{count}</MatrixCellQuantity>{' '}
      <MatrixCellText>{caption}</MatrixCellText>
      {count > 0 && preview.length > 0 && (
        <>
          <ListIcon />
          <PreviewContainer>
            <Popover
              i18nLocale={i18nLocale}
              title={title}
              preview={preview}
              count={count}
            />
          </PreviewContainer>
        </>
      )}
    </ColoredCell>
  );
};

const MatrixCellQuantity = styled.span`
  font-size: 250%;
  margin-right: 0.2em;
  pointer-events: none;
`;

const MatrixCellText = styled.span`
  white-space: nowrap;
  pointer-events: none;
`;

const PreviewContainer = styled(FlexBox).attrs({
  flexDirection: 'column',
  gap: 'medium',
})`
  position: absolute;
  left: 100%;
  top: -${s16};
  z-index: 1;
  display: none;
  padding-left: ${s16};
`;

const ColoredCell = styled(FlexBox).attrs({
  justify: 'center',
  align: 'center',
  padding: 'medium',
  margin: 'small',
})<{ color: string; disabled: boolean }>`
  min-width: 11em;
  border: 0.1em solid lightgrey;
  border-color: ${props => props.color};
  border-radius: ${r8};
  opacity: ${props => (props.disabled ? 0.2 : 1)};
  position: relative;
  color: ${props => props.color};
  ${props =>
    !props.disabled &&
    css`
      &:hover {
        background-color: ${props.color};
        color: ${colors.bgDefault};
        ${PreviewContainer} {
          display: block;
        }
        box-shadow: ${shadowM};
      }
    `}
`;

const ListIcon = styled(FormatListBulletedIcon).attrs({
  iconSize: IconSize.SMALL,
})`
  position: absolute;
  right: ${s4};
  top: ${s4};
`;
